export const CALLING_TICKETS = ['listening_objections', 'calling_improvement'];
export const NOT_ABLE_TO_CLOSE = ['invoice', 'document', 'question'];
